import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@/core/data-fetching/queryKeys';
import { financialPoliciesService } from '../api/financial-policies.service';

export function useAffiliateProgramQuery(enabled = true) {
  return useQuery({ queryKey: queryKeys.affiliateProgram, queryFn: () => financialPoliciesService.affiliateProgram(), enabled, staleTime: 30_000 });
}
